import { combineReducers } from '@reduxjs/toolkit';

import { reducer as selectedTrades } from '../slices/ui/selectedTrades';
import { reducer as trades } from '../slices/tradesList';
import { reducer as tradeSort } from '../slices/ui/tradeSort';
import * as auth from '../slices/auth';
import * as bid from '../slices/bid';
import * as disclosureCount from '../slices/vdp/disclosureCount';
import * as filter from '../slices/filters';
import * as layout from '../slices/ui/layout';
import * as liveBids from '../slices/liveBidsSlice';
import * as media from '../slices/media';
import * as nav from '../slices/ui/nav';
import * as negotiation from '../slices/negotiation';
import * as organization from '../slices/organization';
import * as pending from '../slices/pending';
import * as sse from '../slices/sse';
import * as stateChange from '../slices/stateChangeSlice';
import * as tradeChange from '../slices/tradeChange';
import * as tradeDetails from '../slices/tradeDetails';
import ReducerConstants from '../../_shared/constants/reducers';

const uiReducer = combineReducers({
  nav: nav.default,
  layout: layout.default,
  selectedTrades,
  tradeSort
});

const vdpReducer = combineReducers({
  disclosureCount: disclosureCount.default
});

const rootReducer = combineReducers({
  [ReducerConstants.UI]: uiReducer,
  [ReducerConstants.VDP]: vdpReducer,
  [ReducerConstants.LIVE_BIDS]: liveBids.default,
  [ReducerConstants.STATE_CHANGE]: stateChange.default,
  [ReducerConstants.TRADE_CHANGE]: tradeChange.default,
  [ReducerConstants.TRADE_LIST]: trades,
  [ReducerConstants.TRADE_DETAILS]: tradeDetails.default,
  [ReducerConstants.BID_LIST]: bid.default,
  [ReducerConstants.AUTH]: auth.default,
  [ReducerConstants.MEDIA_METADATA]: media.default,
  [ReducerConstants.ORGANIZATION_DEALER]: organization.default,
  [ReducerConstants.FILTER]: filter.default,
  [ReducerConstants.PENDING_STATE]: pending.default,
  [ReducerConstants.SSE_CONNECTION_STATUS]: sse.default,
  [ReducerConstants.NEGOTIATION_CHANGE]: negotiation.default
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
